// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3rzjp","rootSmall":"AddTileButton_rootSmall__ud1bS"};